import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MembersIconComponent {}
